import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import css from './WhatZScore.module.css';

export const WhatZScore = ({ right }) => {
	return (
		<Link className={classnames(css.root, { [css.right]: right })} to={'/how-it-works/what-is-a-z-score/'}>
			{'What is a z-score?'}
		</Link>
	);
};

export default WhatZScore;
